import { useSelector } from "react-redux";
import ExamsPrincipal from "./principal/ExamsPrincipal.js";
import ExamsTeacher from "./teacher/ExamsTeacher.js";
import ExamsStudent from "./student/ExamsStudent.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import ExamsParent from "./parent/ExamsParent.js";

function Exams() {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <ExamsPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <ExamsTeacher />;
    }
    if (state.auth.user.is_student) {
      return <ExamsStudent />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <ExamsParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
}

export default Exams;
